// extracted by mini-css-extract-plugin
module.exports = {"textBox":"styles_textBox__1WDsP","editor":"styles_editor__22-eF","error":"styles_error__jRhQl","btnAdd":"styles_btnAdd__3rtJZ","errorText":"styles_errorText__229fO"};